<template>
	<div class="c-member" @click="$emit('click')">
		<div v-if="current" class="c-member-crt flex-center"><i class="tf">&#xe63f;</i></div>
		<div v-else class="c-member-icon flex-center" :class="{'s-circle': circle}" :style="{'background': icon ? '#F5F5F5' : '#00A1E9'}">
			<img v-if="icon" :src="icon" alt="">
			<template v-else>
				<span v-for="(item, i) in compName" :key="i">{{item}}</span>
			</template>
		</div>
		<p v-if="text" class="c-member-name ellipsis">{{name}}</p>
		<div v-if="_events.delete" class="c-member-delete flex-center" @click="$emit('delete')"><i class="tf">&#xe60f;</i></div>
	</div>
</template>

<script>
	export default {
		name: 'memberIcon',

		props: {
			icon: String,
			name: String,
			circle: Boolean,
			text: Boolean,
			current: Boolean
		},
		
		computed: {
			compName() {
				return this.name ? this.name.substring(this.name.length - 2, this.name.length).split('') : [];
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.c-member {
		position: relative;
		display: inline-block;
		
		&-crt {
			width: .8rem;
			height: .8rem;
			border-radius: .08rem;
			font-size: .44rem;
			color: #fff;
			background: #00BD3A;
		}
		
		&-icon {
			gap: .04rem;
			width: .8rem;
			height: .8rem;
			border-radius: .08rem;
			margin: 0 auto;
			overflow: hidden;
			font-size: .26rem;
			text-align: center;
			color: #fff;

			&.s-circle {
				border-radius: .4rem;
			}
		}

		&-name {
			max-width: 5em;
			line-height: .56rem;
			font-size: .26rem;
			text-align: center;
			color: #666;
		}

		&-delete {
			position: absolute;
			right: -.08rem;
			top: -.08rem;
			width: .3rem;
			height: .3rem;
			border-radius: 50%;
			font-size: .16rem;
			color: #fff;
			background: #f55;
		}
	}
</style>
